import { useNavigate } from 'react-router-dom';
import type { Property } from '@/services/properties';

interface PropertyCardProps {
  property: Property;
}

export default function PropertyCard({ property }: PropertyCardProps) {
  const navigate = useNavigate();

  return (
    <article
      onClick={() => navigate(`/imovel/${property.id}`)}
      className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:shadow-lg transition-all cursor-pointer"
    >
      {/* Image */}
      <div className="relative h-52 overflow-hidden bg-background-200">
        {property.image ? (
          <img
            src={property.image}
            alt={property.title}
            className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-background-400">
            <i className="ri-image-line text-3xl"></i>
          </div>
        )}
        {/* Tag */}
        <span
          className={`absolute top-3 left-3 px-2.5 py-1 rounded text-[10px] font-bold tracking-wider text-background-50 ${
            property.tag === 'VENDA' ? 'bg-primary-500' : 'bg-secondary-500'
          }`}
        >
          {property.tag}
        </span>
      </div>

      {/* Content */}
      <div className="p-4">
        <p className="text-[11px] text-foreground-600 mb-1">{property.location}</p>
        <h3 className="text-sm font-semibold text-foreground-900 mb-3">{property.title}</h3>

        {/* Details */}
        <div className="flex items-center gap-3 mb-3 text-foreground-600">
          {property.bedrooms > 0 && (
            <span className="flex items-center gap-1 text-xs">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-hotel-bed-line"></i>
              </span>
              {property.bedrooms}
            </span>
          )}
          {property.bathrooms > 0 && (
            <span className="flex items-center gap-1 text-xs">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-showers-line"></i>
              </span>
              {property.bathrooms}
            </span>
          )}
          {property.parking > 0 && (
            <span className="flex items-center gap-1 text-xs">
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-car-line"></i>
              </span>
              {property.parking}
            </span>
          )}
          <span className="flex items-center gap-1 text-xs">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-shape-line"></i>
            </span>
            {property.area}m²
          </span>
        </div>

        {/* Price */}
        <p className="text-base font-bold text-primary-600">{property.price}</p>
      </div>
    </article>
  );
}